import { call, put, select } from 'redux-saga/effects';
import { takeLatest } from 'redux-saga';
import { addToProfile, setCanAddToProfile } from '../modules/Filters';
import { getEndpoints, getInternationalUserProfile } from '../modules/Settings';
import superagent from 'superagent';

const mergeProfileData = ({profile, update}) => {
  Object.keys(update).forEach(key => {
    if (Array.isArray(update[key])) {
      profile[key] = (profile[key] || []).concat(update[key]);
      return;
    }
    if (typeof update[key] === 'object') {
      profile[key] = Object.assign({}, profile[key], update[key]);
      return;
    }
    profile[key] = update[key];
  });

  return profile;
};

export function* addDataToProfile({ payload }) {
  try {
    const { internationalProfileUpdateApi } = yield select(getEndpoints);
    const intUserProfile = yield select(getInternationalUserProfile);

    yield call(superagent.put, internationalProfileUpdateApi, mergeProfileData({
      profile: intUserProfile,
      update: payload,
    }));

    yield put(setCanAddToProfile(Object.assign({ isAdded: true }, payload)));
  } catch (e) {
    console.error(e);
  }
}

export function* watchAddToProfile() {
  yield takeLatest(addToProfile, addDataToProfile);
}
